<template>
    <div class="row">
        <div class="col-8 mx-auto justify-content-center">
            <div class="row justify-content-center dashboardstyle">
                <canvas ref="chart"></canvas>
            </div>
        </div>

    </div>


</template>

<script>
    import {Chart} from 'chart.js';
    export default{

        props:[
            'capital'
        ],

        mounted() {
            var ctx = this.$refs.chart.getContext('2d');
            var gradient = ctx.createLinearGradient(0, 0, 0, 400);

            gradient.addColorStop(0, 'rgba(56, 103, 214,0.3)');
            gradient.addColorStop(0.5, 'rgba(56, 103, 214,0.1)');
            gradient.addColorStop(1, 'rgba(56, 103, 214, 0)');

            var labels = [];
            var prices = [];
            this.capital.forEach(value=>{
                labels.push(value.date);
                prices.push(value.value);
            });


            var graphTab = [];
            var graphTabIndex = 0;


            var capitalGraph = {
                label: 'Votre solde',
                backgroundColor: gradient,
                pointBackgroundColor: 'rgb(99, 91, 255)',
                data: prices,
                fill: true,
                //cubicInterpolationMode:'monotone',
                //pointRadius: 0,
                borderColor:'rgb(99, 91, 255)',
                borderWidth: 2,
            };

            var tailleCapitalTab = prices.length;
            var capitalSomme = 0;
            for (var i=0; i < tailleCapitalTab; i++){
                capitalSomme = capitalSomme + prices[i];
            }
            if(capitalSomme != 0){
                graphTab[graphTabIndex] = capitalGraph;
                graphTabIndex++;
            }

            this.testGraph = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: graphTab,
                },

                options: {
                    scales: {
                        tooltips: {
                            titleFontFamily: "Poppins",
                            titleFontStyle: 'normal',
                            bodyFontFamily: 'Poppins'
                        },
                        legend: {
                            fontFamily: "Poppins"
                        },
                        yAxes:[
                            {
                                stacked: false,
                                ticks: {
                                    beginAtZero: true,
                                    fontFamily: "Poppins",
                                    fontColor: 'rgb(169,169,169)',
                                    fontSize: 10,
                                },
                                gridLines: {
                                    offsetGridLines: true,
                                    display:false
                                },
                            }
                        ],
                        xAxes:[
                            {
                                ticks: {
                                    fontFamily: "Poppins",
                                    fontColor: 'rgb(56, 103, 214)',
                                    fontSize: 10,
                                },
                                gridLines: {
                                    offsetGridLines: true,
                                    display:false
                                },
                                stacked: false,
                            }
                        ]
                    }
                }
            });
        },

        methods: {
        }
    }

</script>
